export const THROTTLE_MS = 1000;
export const TOGGLE_WATCHING_SHORTCUT = 'w' as const;
